import { FaPercent } from 'react-icons/fa';
import { InputIcon } from '../../../../../components/InputIcon';
import { useCustomTheme } from '../../../../../hooks/useCustomTheme';

export const InputDescontoPercentual = ({ ...props }) => {
  const {
    theme: { colors },
  } = useCustomTheme();

  return (
    <InputIcon
      icon={<FaPercent color={colors.textSecondary} />}
      iconPosition="right"
      {...props}
    />
  );
};
